import { Images } from '@/assets/images';
import { REGEX } from '@/constant';
import {
	cn,
	convertProductionTypeCodeToName,
	dayjs,
	formatDate,
} from '@/utils';

import { FormConfig } from '../define-document-write.type';

const initializeValue = {
	safetyInsuranceName: '',
	safetyInsuranceSectors: '',
	safetyInsuranceRegistDate: '',
	safetyInsuranceRepresentativeName: '',
	safetyInsuranceSignature: '',
	safetyInsuranceBranchOffice: '',
	safetyInsuranceId: '',
	safetyInsuranceReferId: '',

	//get from DB
	safetyInsuranceRecruiterResidentNo: '',
	franchisePostalCode: '',
	franchiseAddr: '',
	franchiseAddrNum: '',
	safetyInsuranceFranchiseAddr: '',
	safetyInsuranceFranchisePhone: '',
	safetyInsuranceRecruiterPhone: '',
	safetyInsuranceRecruiterEmail: '',
	safetyInsuranceFranchiseType: '',
};

type IValues = typeof initializeValue;

export const CONFIRMATION_OF_SUBSCRIPTION_TO_AGRICULTURAL_AND_FISHERMAN_SAFETY_INSURANCE_CONFIG: FormConfig<IValues> =
	{
		initializeValue,
		title: '농/어업인 안전보험 가입 확약서',
		mapPropToValues: ({ franchiseData }) => {
			return {
				safetyInsuranceName: franchiseData?.name,
				safetyInsuranceRecruiterResidentNo: `${formatDate(franchiseData?.employerBirthDate, { outputFormat: 'YYMMDD' })} / ${franchiseData?.businessRegistNo}`,
				safetyInsuranceFranchiseAddr: franchiseData?.address,
				safetyInsuranceFranchisePhone: franchiseData?.phone,
				safetyInsuranceRecruiterPhone: franchiseData?.employerPhone,
				safetyInsuranceRecruiterEmail: franchiseData?.email,
				safetyInsuranceFranchiseType: `${convertProductionTypeCodeToName(franchiseData?.productionType) || ''}${franchiseData?.productionTypeDetail ? `(${franchiseData?.productionTypeDetail})` : ''}`,
				safetyInsuranceRepresentativeName: franchiseData?.employerName,

				safetyInsuranceRegistDate: formatDate(dayjs()),
			};
		},
		pages: [
			{
				background: {
					src: Images.formConfirmationOfSubscriptionToAgriculturalAndFishermanSafetyInsurance,
					className: 'template w-full',
					dataSource:
						Images.formConfirmationOfSubscriptionToAgriculturalAndFishermanSafetyInsurance,
				},
				textAreas: [
					(data, index) => ({
						name: 'safetyInsuranceName',
						maxHeight: 40,
						maxLength: 20,
						containerClassName: cn(
							'absolute top-[292px] left-[66px] w-[300px]',
							data.safetyInsuranceName && 'bg-white '
						),
						className: 'text-[17.33px] leading-none',
					}),
					{
						name: 'safetyInsuranceRecruiterResidentNo',
						maxHeight: 40,
						maxLength: 25,
						containerClassName: 'absolute top-[291px] left-[47%] w-[324px]',
						className: 'text-[17.33px] leading-none',
					},
					{
						name: 'safetyInsuranceFranchiseAddr',
						maxHeight: 28,
						maxLength: 60,
						containerClassName: 'absolute top-[354px] left-[65px] w-[630px]',
						className: 'text-[17.33px] leading-none',
					},
					{
						name: 'safetyInsuranceFranchisePhone',
						maxHeight: 28,
						maxLength: 15,
						containerClassName: 'absolute top-[404px] left-[65px] w-48',
						regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
						className: 'text-[17.33px] leading-none',
					},
					{
						name: 'safetyInsuranceRecruiterPhone',
						maxHeight: 28,
						maxLength: 15,
						containerClassName: 'absolute top-[404px] left-[376px] w-56',
						regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
						className: 'text-[17.33px] leading-none',
					},
					{
						name: 'safetyInsuranceRecruiterEmail',
						maxHeight: 28,
						maxLength: 50,
						containerClassName: 'absolute top-[453px] left-[65px] w-[630px]',
						className: 'text-[17.33px] leading-none',
					},
					// {
					// 	name: 'safetyInsuranceFranchiseType',
					// 	maxHeight: 44,
					// 	maxLength: 35,
					// 	containerClassName: 'absolute top-[32%] left-[53.4%] w-72',
					// },
					// {
					// 	name: 'safetyInsuranceBranchOffice',
					// 	maxHeight: 44,
					// 	maxLength: 10,
					// 	containerClassName: 'absolute bottom-[11%] left-[11%] w-[150px]',
					// 	className: 'text-base text-right',
					// 	regex: REGEX.ALLOW_KR_SPACE,
					// 	placeholder: 'OO',
					// },
					{
						name: 'safetyInsuranceRepresentativeName',
						maxHeight: 55,
						maxLength: 40,
						containerClassName:
							'absolute top-[800px] left-[337px] w-[143px] h-[50px]',
						className: 'text-[17.33px] leading-none',
					},
				],
				datePickers: [
					{
						name: 'safetyInsuranceRegistDate',
						segmentedInputs: true,
						containerClassName: 'absolute top-[760px] left-[35.6%]',
						format: ' YYYY           MM                DD',
						style: { fontSize: '14px' },
					},
				],
				signatures: [
					{
						name: 'safetyInsuranceSignature',
						className: 'absolute top-[817px] left-[515px] w-[123px] h-[50px]',
					},
				],
				highlightBoxes: [
					{
						name: 'safetyInsuranceName',
						className: 'w-[85px] !h-[21px] top-[275px] left-[66px]',
					},
					{
						name: 'safetyInsuranceRecruiterResidentNo',
						className: 'w-[317px] !h-[21px] top-[275px] left-[376px]',
					},
					{
						name: 'safetyInsuranceFranchiseAddr',
						className: 'w-[135px] !h-[21px] top-[334px] left-[66px]',
					},
					{
						name: 'safetyInsuranceFranchisePhone',
						className: 'w-[112px] !h-[21px] top-[384px] left-[66px]',
					},
					{
						name: 'safetyInsuranceRecruiterPhone',
						className: 'w-[95px] !h-[21px] top-[384px] left-[376px]',
					},
					{
						name: 'safetyInsuranceRecruiterEmail',
						className: 'w-[114px] !h-[21px] top-[433px] left-[66px]',
					},
					{
						name: 'safetyInsuranceRegistDate',
						className: 'w-[205px] !h-[21px] top-[760px] left-[274px]',
					},
					{
						name: 'safetyInsuranceRepresentativeName',
						className: 'w-[187px] !h-[21px] top-[817px] left-[142px]',
					},
					{
						name: 'safetyInsuranceSignature',
						className: 'w-[122px] !h-[21px] top-[817px] left-[489px]',
					},
				],
			},
		],
	};
